import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TopLineTitle from '../atoms/titles/TopLineTitle';
import Tag from '../atoms/tag/Tag';
import TextLink from '../atoms/link/Textlink';
import Caution from '../molecules/Caution';
import ModalOtherPage from '../modal/ModalOtherPage';

const FacilityDetail = ({ hotel, hideDetailLink }) => {
  const [showPlanDetailModal, setShowPlanDetailModal] = useState(false);
  if (!hotel) {
    return null;
  }

  const {
    id: hotelId,
    name,
    recommendationPoint,
    picsURL,
    access,
    tags,
    detailURL,
    mapURL,
    area,
    message,
    specialMeasures,
  } = hotel;


  // workaround https://gitlab.fqsv.net/dp-plus/front/issues/104 cant use <a>tag
  const planDetaillink = detailURL;
  const onClickDetailLink = () => setShowPlanDetailModal(true);
  const onCloseDetailModal = () => setShowPlanDetailModal(false);

  return (
    <div className="FacilityDetail">
      <TopLineTitle
        name={name}
        area={`${area.prefectureName}/${area.areaName}`}
        hideDetailLink={hideDetailLink}
        onClickDetailLink={onClickDetailLink}
      />
      <div className="FacilityInfo">
        <div className="thumbnail">
          <div className="thumbnailImage">
            <img src={picsURL} alt="" />
          </div>
        </div>
        <div className="detail">
          <p dangerouslySetInnerHTML={{ __html: recommendationPoint }} />
          <div className="access">
            <div className="title">アクセス</div>
            <div
              className="accessList"
              dangerouslySetInnerHTML={{ __html: access }}
            />
            <div className="facilityDetailTagItems">
              {tags.map((c) => (
                <div key={c.id} className="tagItem">
                  <Tag>{c.name}</Tag>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {specialMeasures && (
        <div className="specialMeasures">
          <div className="pr_label_wrap">
            <link href="https://ecwww9.nta.co.jp/test_search/style.css" rel="stylesheet" media="all" />
            <ul className="pr_label">
              <li className="pr_icon_01">{specialMeasures}</li>
            </ul>
          </div>
          <span className="note">必ず<a href="https://www.nta.co.jp/kokunai/special/ouen/kyushu/" target="_blank">ご利用条件・ご案内</a>をご確認の上、お申込みください。</span>
        </div>
      )}
      <Caution message={message} />
      <ModalOtherPage
        open={showPlanDetailModal}
        onClose={onCloseDetailModal}
        srcUrl={planDetaillink}
      />
    </div>
  );
};

FacilityDetail.defaultProps = {
};

FacilityDetail.propTypes = {
  hotel: PropTypes.object,
  hideDetailLink: PropTypes.bool,
};

export default FacilityDetail;
